import { Countdown, Player, PlayerAction } from "../../../types";
import Avatar from "../../common/avatar/avatar";
import CountdownComponent from "../../common/countdown/countdown";
import React, { useState } from "react";
import { GameStatus } from "../../../types/game-status";
import ClickableAvatar from "../../common/clickable-avatar/clickable-avatar";
import { useAppSelector } from "../../../redux/store";
import GamePage from "../game-page/game-page";

type Props = {
  header: string;
  subHeader?: string;
  players?: Player[];
  countdown?: Countdown;

  onPlayerAction?: (playerAction: PlayerAction) => void;
  loading?: boolean;

  children?: React.ReactNode;
};

const Waiting = ({
  header,
  players,
  countdown,
  onPlayerAction,
  loading,
  subHeader,
}: Props) => {
  const gameState = useAppSelector((state) => state.game);
  const playerState = useAppSelector((state) => state.player);

  const [clickedGuy, setClickedGuy] = useState<number>();

  const [clicky, setClicky] = useState(0);

  function amHost() {
    return gameState.game?.host_id === playerState.player?.id;
  }

  function handleBoot() {
    if (onPlayerAction) {
      if (!clickedGuy) {
        console.log("undefined player");
        return;
      }

      if (clicky === 0) {
        setClicky(1);
        return;
      }

      setClicky(0);
      let playerAction = {
        body: {
          vip_action: {
            kick_player: clickedGuy,
          },
        },
        code: "game/vip",
      };
      onPlayerAction(playerAction);
      setClickedGuy(undefined);
    }
  }

  React.useEffect(() => {
    if (!clickedGuy) {
      setClicky(0);
    }
  }, [clickedGuy]);

  function handleClick(player: Player) {
    setClickedGuy((prevState) =>
      prevState === player.id ? undefined : player.id
    );
  }

  function clickyText() {
    if (
      gameState.game?.status_str === GameStatus.GameStatusLobby ||
      gameState.game?.status_str === GameStatus.GameStatusQuickStart ||
      gameState.game?.status_str === GameStatus.GameStatusCharacters ||
      gameState.game?.status_str === GameStatus.GameStatusStoryCreate
    ) {
      return "kick player";
    } else if (
      gameState.game?.status_str === GameStatus.GameStatusStoryTitle ||
      gameState.game?.status_str === GameStatus.GameStatusVoting ||
      gameState.game?.status_str === GameStatus.GameStatusReacting
    ) {
      return "skip player";
    }
  }

  return (
    <GamePage
      titles={[header]}
      subHeaders={amHost() && subHeader ? [subHeader] : []}
      footerJsx={
        countdown && countdown.deadline !== 0 ? (
          amHost() ? (
            <CountdownComponent
              countdown={countdown}
              actionButton={{
                text: clicky === 0 ? clickyText() || "action" : "are you sure?",
                onClick: handleBoot,
                disabled: players?.length === 0 || !clickedGuy,
                loading: loading,
              }}
            />
          ) : (
            <CountdownComponent countdown={countdown} />
          )
        ) : (
          <></>
        )
      }
    >
      <div
        className={
          "flex-grow text-base flex flex-col justify-center items-center"
        }
      >
        <div
          className={
            "self-stretch text-2xl p-2 flex flex-wrap flex-row justify-around items-center"
          }
        >
          {players?.map((p) =>
            amHost() ? (
              <ClickableAvatar
                key={p.id}
                player={p}
                onClick={handleClick}
                checked={clickedGuy === p.id}
              />
            ) : (
              <Avatar
                key={p.id}
                name={p.name}
                spriteId={p.meta.sprite_id}
                size="small"
                variant="basic"
              />
            )
          )}
        </div>
      </div>
    </GamePage>
  );
};
export default Waiting;
